<template>
  <div>
    <page-title title="Criar nova tabela de medidas no Mercado Livre"/>
    <panel title="Configurações iniciais">
      <form-group :columns="4" label="Conta" :required="true" :error="getError('account')">
        <select class="form-select" v-model="account">
          <option value="">Selecione</option>
          <option v-for="account in mercadoLivreAccounts" :key="account.identifier" :value="account.identifier">
            {{ account.name }} ({{ account.nickname }})
          </option>
        </select>
      </form-group>

      <general-category v-on:loading="isLoader" @selectedCategory="setSelectedCategory"/>

      <form-group :columns="4" label="Gênero" :required="true" :error="getError('gender')">
        <select class="form-select" v-model="gender">
          <option value="">Escolha</option>
          <option v-for="gender in genders" :value="gender">{{ gender.name }}</option>
        </select>
      </form-group>
    </panel>

    <panel v-if="showSizeAttributes()" title="Valores da Guia de Medidas">
      <form-group label="Nome da Guia de Medidas" :required="true" :error="getError('name')" :columns="4">
        <input class="form-input" type="text" v-model="name">
      </form-group>
      <form-group label="Marca" :columns="4" :required="true" :error="getError('brand')">
        <select class="form-select" v-model="brand">
          <option value="">Escolha</option>
          <option v-for="brand in brands" :value="brand">{{ brand }}</option>
        </select>
      </form-group>
    </panel>

    <panel v-if="sizeAttributes" title="Tabela de Medidas">
      <loader :loading="loadingSizeGrids"/>
      <form-group label="Tamanho Principal" v-if="mainSizesOptions.length > 0" class="form-group l-col-12@md" :required="true" :error="getError('mainSize')">
        <ul class="radio-inline">
          <li v-for="(value, k) in mainSizesOptions">
            <input type="radio" :value="value.id" v-model="mainSize" :checked="k === 0"> <span>{{ value.name }}</span>
          </li>
        </ul>
      </form-group>
      <div class="l-row sizeRowItem" v-for="(sizeRow, i) in sizeRows">
        <div v-if="sizeRows.length > 1" class="hrTitle"><span class="hr"></span>{{ i + 1 }}<span class="hr right"></span></div>
        <div class="l-col-2" v-for="attribute in sizeAttributes" v-if="attribute.mainAttribute === undefined || attribute.mainAttribute === false ">
          <form-group :label="attribute.label" class="form-group l-col-12@md" :required="attribute.required" :error="getError(attribute.id, i)">
            <input v-if="attribute.type === 'text'" type="text" class="form-input" :placeholder="getPlaceholder(attribute)" v-model="sizeRows[i][attribute.id]">
            <input v-if="attribute.type === 'number'" type="text" @change="validates(attribute, i)" class="form-input" v-mask="'###.## cm'" v-model="sizeRows[i][attribute.id]" :placeholder="'999.99 ' + attribute.unity">

            <multiselect
              v-if="attribute.type === 'multiselect'"
              v-model="sizeRows[i][attribute.id]"
              :options="attribute.values"
              selectLabel=""
              selectedLabel=""
              :multiple="true"
              placeholder="Escolha"
              label="name"
              track-by="id"
            />

            <span v-if="attribute.min && attribute.max"><small>entre {{ attribute.min }} e {{ attribute.max }} {{ attribute.unity}} * </small></span>
          </form-group>
        </div>
        <div class="l-col-2">
          <button class="btn btn--info" @click="removeSize(i)" :disabled="sizeRows.length < 2" style="background-color: #ed3e3e; border-color: #ed3e3e; margin-top: 22px;">Remover</button>
        </div>
      </div>
      <button class="btn btn--default" style="margin-left: 8px" @click="addSizeRow">Adicionar Tamanho</button>
    </panel>

    <panel>
      <button :disabled="saving" @click="save()" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" type="submit">Criar</button>
    </panel>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import GeneralCategory from '@/components/marketplace/mercadoLivre/sizeGrid/general/Category'
  import RadioButton from '@/components/template/RadioButton'
  import Loader from '@/components/template/Loader'
  import Multiselect from 'vue-multiselect'

  class SizeRow {
  }

  export default {
    data: () => ({
      account: '',
      mercadoLivreAccounts: [],
      brands: [],
      genders: [],
      mainSize: null,
      hasMainSizeOption: false,
      errorMessages: [],
      name: null,
      category: null,
      gender: null,
      brand: null,
      saving: false,
      loadingSizeGrids: false,
      sizeRows: [],
      sizeAttributes: null,
      permissionProductSelected: 'notPermission',
      permissionOrderSelected: 'notPermission',
      productSimpleOptions: null,
      orderSimpleOptions: null,
      productAdvancedOptions: [],
      orderAdvancedOptions: []
    }),
    async mounted () {
      this.mercadoLivreAccounts = (await api.mercadoLivre.getAccounts({})).items

      let moovinBrands = []
      let ecomeceBrands = []

      try {
        moovinBrands = (await api.getBrands('ecommerce', 'moovin'))
      } catch (error) {
        moovinBrands = []
      }

      try {
        ecomeceBrands = (await api.getBrands('ecommerce', 'ecomece'))
      } catch (error) {
        ecomeceBrands = []
      }

      this.brands = moovinBrands.concat(ecomeceBrands)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors',
        'clearError',
        'getError',
        'getErrors'
      ]),
      getPlaceholder (attribute) {
        if (attribute.unity == null) {
          return 'M ou M.G'
        }
        if (attribute.unity === 'US') {
          return '2 ou 10.11' + attribute.unity
        }
        return '30 ou 30.31 ' + attribute.unity
      },
      validates (attribute, i) {
        var hasError = false

        if (attribute.min !== null) {
          if (parseFloat(this.sizeRows[i][attribute.id]) < attribute.min) {
            hasError = true
          }
        }

        if (attribute.max !== null) {
          if (parseFloat(this.sizeRows[i][attribute.id]) > attribute.max) {
            hasError = true
          }
        }

        if (hasError) {
          this.addError({
            property: attribute.id,
            productId: i,
            error: {
              message: 'errorSizeGridRange',
              value: 1
            }
          })
        } else {
          this.clearError({attribute: attribute.id, sizeRow: i})
        }
      },
      async loadTechnicalSpecs () {
        this.sizeAttributes = null
        this.loadingSizeGrids = true

        let data = {
          category: this.category,
          brand: this.brand,
          gender: this.gender
        }

        await api.mercadoLivre.getDomainTechnicalSpecs(data, this.account)
          .then((data) => {
            this.sizeAttributes = data
            this.mainSizesOptions = []
            this.mainSize = null
            this.sizeAttributes.forEach(attribute => {
              if (attribute.mainAttribute !== undefined && attribute.mainAttribute && attribute.id === 'mainSize') {
                this.mainSizesOptions = attribute.values
              }
            })
            this.sizeRows = []
            this.addSizeRow()
            this.loadingSizeGrids = false
          })
          .catch(() => {
            this.loadingSizeGrids = false
          })
      },
      showSizeAttributes () {
        if (this.brand === '' || this.category === null || this.gender === null) {
          return false
        }
        return true
      },
      addSizeRow () {
        this.sizeRows.push(new SizeRow())
      },
      save () {
        this.clearErrors()

        this.saving = true

        if (this.account === '') {
          this.addError({
            property: `account`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.name === null) {
          this.addError({
            property: `name`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.gender === '') {
          this.addError({
            property: `gender`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        if (this.brand === '') {
          this.addError({
            property: `brand`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        let sizeGrid = {}

        if (this.name) {
          sizeGrid.name = this.name
        }

        if (this.account) {
          sizeGrid.account = this.account
        }

        if (this.name) {
          sizeGrid.name = this.name
        }

        if (this.gender) {
          sizeGrid.gender = this.gender
        }

        if (this.brand) {
          sizeGrid.brand = this.brand
        }

        if (this.mainSize) {
          sizeGrid.mainSize = this.mainSize
        }

        if (this.category) {
          sizeGrid.category = this.category
        }

        if (this.sizeRows) {
          sizeGrid.sizes = this.sizeRows
        }

        api.mercadoLivre.createSizeGrid(sizeGrid, sizeGrid.account)
          .then(() => {
            notifier.success('Tabela de medidas cadastrada com sucesso!', 'Sucesso')
            this.$router.push('/marketplace/mercadoLivre/sizegrids')
            this.saving = false
          })
          .catch(() => {
            notifier.error('Erro ao cadastrar a tabela de medidas, verifique as informações!', 'Erro')
            this.saving = false
          })
      },
      isLoader (status) {
        this.loading = status
      },
      async setSelectedCategory (selectedCategory) {
        try {
          const accountId = await api.mercadoLivre.getActiveAccountId()
          var infos = await api.mercadoLivre.getCategoryInfo(accountId, selectedCategory, 'SIZE_-_COLOR')
          infos.attributes.forEach(attribute => {
            if (attribute.id === 'GENDER') {
              this.genders = attribute.values
            }
          })
        } catch (e) { }

        this.category = selectedCategory
      },
      onChangeMainAttributes () {},
      removeSize (i) {
        this.sizeRows.splice(i, 1)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError',
        'getErrors'
      ])
    },
    watch: {
      gender () {
        this.loadTechnicalSpecs()
      },
      category () {
        this.loadTechnicalSpecs()
      }
    },
    components: {
      PageTitle,
      Panel,
      FormGroup,
      Multiselect,
      GeneralCategory,
      RadioButton,
      Loader
    }
  }
</script>

<style scoped>
  div ul {
    padding: 0px;
  }
  .sizeRowItem {
    padding-top: 1.6pc;
  }
  .sizeRowItem .hrTitle {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3pc;
    text-align: center;
    position: relative;
    color: #b9b9b9;
  }
  .sizeRowItem .hrTitle span.hr {
    width: 9%;
    height: 1px;
    background-color: #d7d3d3;
    position: absolute;
    left: 39%;
    top: 9px;
  }
  .sizeRowItem .hrTitle span.hr.right {
    left: 52% !important;
  }
  ul.radio-inline {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// Create.vue?6f5f49c9